import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FullFileDataResponse } from '../../../../core/interfaces/file-upload-interfaces';
import { TranslocoPipe } from '@jsverse/transloco';
import { ToastComponent } from '../../../../shared/components/toast/toast.component';

@Component({
  selector: 'app-file-details-view',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './file-details-view.component.html',
  styleUrl: './file-details-view.component.css'
})
export class FileDetailsViewComponent {
  @Input() fileDetailsResponse: FullFileDataResponse | null = null;
  @Input() toast!: ToastComponent;

  expanded: { [key: string]: boolean } = {};

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  toggleSection(key: string) {
    this.expanded[key] = !this.expanded[key];
  }

  formatJson(value: any): string {
    return JSON.stringify(value, null, 2);
  }

  copyToClipboard(data: any): void {
    const formatted = this.formatJson(data);
    navigator.clipboard.writeText(formatted).then(
      () => {
        this.toast.showToast('shared.success', 'admin.code_copied', 'success', 2000, true);
      },
      (err) => {
      }
    );
  }

}
